export const locales = {
  en: {
    common: () => import("./en/common.json"),
    content: () => import("./en/content.json"),
  },
};
